import PropTypes from "prop-types"
import { Navigate, Outlet } from "react-router-dom"
import MainContent from "../../components/Products/MainContent"

const RouteMiddleware = ({ isProtected }) => {
  return isProtected && localStorage.getItem("token") ? (
    <Outlet />
  ) : (
    <Navigate to={{ pathname: "/login" }} />
  )
}

RouteMiddleware.propTypes = {
  isProtected: PropTypes.bool,
}

export default RouteMiddleware
